import { createContext } from '@berlin-front/common/composables/context';
import { AtoneMemberTypePostResponseMemberTypeEnum } from '@netprotections/berlin-bff';
import { reactive, UnwrapRef } from '@vue/composition-api';

export type AtoneAuthIntroType = {
  useIntro: () => UnwrapRef<{
    /** メンバー種別 */
    memberType: AtoneMemberTypePostResponseMemberTypeEnum;
    /** サービス内容説明URL */
    SERVICE_DESCRIPTION_URL: string;
    /** atoneログインフローへの遷移を行う。 */
    goToAtoneauthLogin: () => void;
    /** atone登録フローへの遷移を行う。  */
    goToAtoneauthRegisterAccount: () => void;
    /** atone登録フローへの遷移を行う。  */
    goToAtoneauthRegisterNpAccount: () => void;
  }>;
};

export const AtoneAuthIntroContext = createContext<AtoneAuthIntroType>({
  // ここはダミー実装。実際にはrouterからAuthIntroが流し込まれる。
  useIntro: () =>
    reactive({
      memberType: AtoneMemberTypePostResponseMemberTypeEnum.NUMBER_0,
      SERVICE_DESCRIPTION_URL: 'https://example.com/',
      goToAtoneauthLogin: () => {},
      goToAtoneauthRegisterAccount: () => {},
      goToAtoneauthRegisterNpAccount: () => {},
    }),
});
